// ***************  New Microservices API for Building Data ********************//

import { intelApi } from "./http-client";

//  get Default Building
export const getNewDefaultBuilding = (payload) => {
	return intelApi.post("get-default-building", payload);
};
//  get Default Building
export const SaveDefaultBuilding = (payload) => {
	return intelApi.post("default-building", payload);
};

//  get  Building data
export const getNewBuildingData = (payload) => {
    return intelApi.post("get-building-data", payload);
};
//  get Building Color
export const getNewBuildingColor = (payload) => {
	return intelApi.post("get-building-color", payload);
};
//  get building Material
export const getBuildimgmaterial = (payload) => {
	return intelApi.post("get-building-material", payload);
};

// get building door/window pricing
export const getBuildingDoorWindowPricing = (payload) => {
    return intelApi.post("get-components-price", payload);
}
export const getBuildingPricing = (payload) => {
	return intelApi.post("get-building-price", payload);
};
export const getBuildingLeanToPrice = (payload) => {
	return intelApi.post("get-lean-to-price", payload);
};



